import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  const displayCategories = categories;

  return (
    <section id="kategorie" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between mb-12 md:mb-16">
          <div>
            <p className="text-xs md:text-sm font-medium text-primary-600 tracking-wider uppercase mb-2 font-label">
              Kategorie produktów
            </p>
            <h2 className="text-3xl md:text-5xl lg:text-6xl font-bold font-heading text-foreground-950 leading-tight">
              Odkryj nasze
              <br />
              <span className="italic font-normal text-primary-600">kolekcje 2026</span>
            </h2>
          </div>
          <div className="hidden lg:block">
            <div className="w-24 h-px bg-primary-300 mt-2"></div>
            <div className="w-16 h-px bg-primary-200 mt-1.5 ml-4"></div>
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
          {displayCategories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group block rounded-2xl overflow-hidden bg-white cursor-pointer transition-all duration-300 hover:-translate-y-1"
            >
              <div className="relative aspect-[4/5] overflow-hidden">
                <img
                  src={cat.image}
                  alt={`usfansspreadsheet ${cat.name}`}
                  title={`USFansSpreadsheet - ${cat.name}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-3 md:p-4">
                  <h3 className="text-sm md:text-base font-bold text-white drop-shadow-md whitespace-nowrap">
                    {cat.name}
                  </h3>
                </div>
              </div>
              <div className="px-4 py-3.5 bg-white">
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                  {cat.description}
                </p>
                <span className="inline-flex items-center gap-1 mt-2 text-xs font-semibold text-primary-600 whitespace-nowrap">
                  Przeglądaj teraz
                  <i className="ri-arrow-right-s-line"></i>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}